import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = {
  key: 0,
  class: "p-3 border-bottom"
}
const _hoisted_3 = {
  key: 2,
  class: "formContainer mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar_provider = _resolveComponent("navbar-provider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_navbar_provider),
    _createElementVNode("div", {
      class: _normalizeClass(["pageContainer", _ctx.scrollable])
    }, [
      (_ctx.selectedLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.selectedLabel), 1))
        : _createCommentVNode("", true),
      (_ctx.canOpenProfile)
        ? (_openBlock(), _createBlock(_component_router_view, { key: _ctx.currentProfileId }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              type: "h2",
              localizedKey: "Select supplier",
              text: "Select supplier"
            }),
            _createVNode(_component_localized_text, {
              localizedKey: "Choose a supplier to manage its questionnaires",
              text: "Choose a supplier from the menu to open its profile and questionnaires. Pending invitations are accepted when opened."
            })
          ]))
    ], 2)
  ]))
}